<template>
    <div class="Curso">
        <v-container grid-list-xl fluid v-show="!showDetails" class="pt-0">
            <v-layout row wrap>
                <v-flex sm4 v-if="estudianteExpand">
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa-cog</v-icon>
                                Detalles del Estudiante
                            </v-toolbar-title>
                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon color="primary" dark @click="estudianteExpand = false">
                                            <v-icon v-on="on">{{ getEstudianteSeccionIcon() }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ocultar</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid grid-list-xl>
                                <v-layout align-center wrap>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Nombre:</v-flex>
                                    <v-flex sm5>{{ estudianteData.nombre ? estudianteData.nombre : "-" }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Apellidos:</v-flex>
                                    <v-flex sm5>{{
                                        estudianteData.apellido_paterno
                                            ? estudianteData.apellido_paterno + " " + estudianteData.apellido_materno
                                            : "-"
                                    }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Matrícula:</v-flex>
                                    <v-flex sm5>{{ estudianteData.matricula ? estudianteData.matricula : "-" }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Fecha de nacimiento:</v-flex>
                                    <v-flex sm5>{{
                                        estudianteData.fecha_nacido ? estudianteData.fecha_nacido : "-"
                                    }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Fecha de alta:</v-flex>
                                    <v-flex sm5>{{
                                        estudianteData.fecha_alta ? estudianteData.fecha_alta : "-"
                                    }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Estado:</v-flex>
                                    <v-flex sm5>{{
                                        estudianteData.status_description ? estudianteData.status_description : "-"
                                    }}</v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex :class="estudianteExpand ? 'sm8' : 'sm12'">
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-scroll-x-transition>
                                <template v-if="!estudianteExpand">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" dark @click="estudianteExpand = true">
                                                <v-icon v-on="on">{{ getEstudianteSeccionIcon() }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contraer</span>
                                    </v-tooltip>
                                </template>
                            </v-scroll-x-transition>

                            <v-toolbar-title>
                                <v-icon medium>fa fa-graduation-cap</v-icon>
                                Lista de Cursos
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="cursoEstado"
                                    label="Cursos"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Habilitados', value: '2' },
                                        { text: 'Deshabilitados', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadCurso()"
                                >
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-menu
                                    v-model="menufiltro"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-curso
                                        v-if="menufiltro"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-curso>
                                </v-menu>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Curso</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="CURSOS"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.tarifa ? props.item.tarifa.nombre : "-" }}</td>
                                        <td>
                                            {{
                                                props.item.pago_colegiatura
                                                    ? props.item.pago_colegiatura.colegiatura_base
                                                    : "-"
                                            }}
                                        </td>
                                        <td>
                                            {{ props.item.grado ? props.item.grado.nombre : "-" }}
                                        </td>
                                        <td>
                                            {{ props.item.grupo ? props.item.grupo.letra : "-" }}
                                        </td>
                                        <td>
                                            {{ props.item.status_description }}
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :disabled="loading || menuLocked"
                                                            @click="openDetails(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-eye</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver detalles</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="orange"
                                                            :disabled="loading || menuLocked"
                                                            @click="openForm(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Curso</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="red"
                                                            :disabled="loading || menuLocked"
                                                            @click="deleteItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar Curso</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :loading="loadingHistory"
                                                            @click="loadHistory(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver historial</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen cursos registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <curso-form
            v-if="showForm"
            :form-title="title"
            :initial-item="editItem"
            :estudiante-id="estudianteId"
            @formCanceled="closeForm"
        >
        </curso-form>
        <curso-details v-if="showDetails" :item="detailsItem" @detailsCanceled="closeDetails"> </curso-details>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Curso'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
const TimeLine = () =>
    import(/* webpackChunkName: "historial-time-line" */ "@/components/widgets/records-time-line/time-line")
const CustomFilterCurso = () =>
    import(/* webpackChunkName: "curso-filter" */ "@/components/widgets/custom-filter-curso/custom-filter-curso")
const CursoForm = () => import(/* webpackChunkName: "curso-form" */ "@/components/cobranza/curso/curso-form")
const CursoDetails = () => import(/* webpackChunkName: "curso-details" */ "@/components/cobranza/curso/curso-details")

export default {
    components: { CustomFilterCurso, CursoForm, CursoDetails, TimeLine },
    props: {
        estudianteParam: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [
            { text: "Tarifa", value: "tarifa_id" },
            { text: "Colegiatura", value: "colegiatura_id" },
            { text: "Grado", value: "grado" },
            { text: "Grupo", value: "grupo_id" },
            { text: "Estado", value: "estado" }
        ],
        editItem: null,
        totalItems: 0,

        deleteCursoConfirmId: "",

        menuLocked: false,

        showDetails: false,
        detailsItem: null,

        //filtro personalizado
        menufiltro: false,
        customFilter: null,
        activeFilters: 0,

        //estado de los cursos a cargar del back
        cursoEstado: "1",

        //estudiante del que proviene
        estudianteId: null,

        //meses
        mesesItem: Util.yearMonths(),

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //seccion del estudiante
        estudianteExpand: true,
        estudianteData: true,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_CURSOS", {
                    estudianteId: this.estudianteId,
                    cursoEstado: estado,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar curso"
                this.editItem = item
            } else {
                this.title = "Nuevo curso"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteCursoConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteCursoConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_CURSO", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteCursoConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteCursoConfirmId = ""
            props.expanded = !props.expanded
        },

        loadCurso() {
            this.loadData(this.cursoEstado)
            this.customFilter = null
            this.activeFilters = 0
        },

        closeDetails() {
            this.showDetails = false
            this.detailsItem = null
        },

        openDetails(props) {
            let curso = this.CURSOS.filter(el => el.id === props.item.id)[0]
            if (curso.grado) {
                this.detailsItem = props.item
                this.showDetails = true
            } else {
                //condicion para saber si los datos de este empleado no se han cargaron para pedirlos
                this.loading = true
                this.$store.dispatch("LOAD_CURSO_DETAILS", props.item).then(error => {
                    if (error === null) {
                        this.detailsItem = props.item
                        this.loading = false
                        this.showDetails = true
                    } else {
                        this.loading = false
                    }
                })
            }
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.menufiltro = false
                this.cursoEstado = "6"
                this.customfilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.cursoEstado, this.customfilter)
            } else {
                this.cursoEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.cursoEstado, this.customfilter)
                this.menufiltro = false
            }

            this.filterInternalState = {
                inputs: value.internalState.inputs,
                selectedCampos: value.internalState.selectedCampos
            }
        },

        loadHistory(props) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Curso")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: props.item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        getEstudianteSeccionIcon() {
            return this.estudianteExpand ? "fa-angle-left" : "fa-angle-right"
        }
    },

    computed: {
        ...mapGetters(["CURSOS"]),

        pagination: {
            get: function() {
                return this.$store.getters.CURSOS_PAG
            },
            set: function(value) {
                this.$store.commit("SET_CURSOS_PAG", value)
            }
        }
    },

    watch: {
        pagination: {
            handler() {
                this.loadData(this.cursoEstado, this.customfilter)
            },
            deep: true
        }
    },

    created() {
        if (this.estudianteParam) {
            localStorage.setItem("estudiante_id", JSON.stringify(this.estudianteParam))
        }
    },

    mounted() {
        let estudiante = localStorage.getItem("estudiante_id")
        this.estudianteId = JSON.parse(estudiante)

        this.$store.dispatch("LOAD_ESTUDIANTE_DETAILS_CURSO", { id: this.estudianteId }).then(result => {
            if (result) {
                this.estudianteData = result
            }
        })
    }
}
</script>
